export default __webpack_public_path__ + "static/media/pqs.10a4f796.png";